import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Auth() {
  const t = useTheme();
  const { login, register } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get("redirect");
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ email: "", password: "", name: "", phone: "" });
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      if (mode === "login") await login(form.email, form.password);
      else await register(form);
      toast.success(mode === 'login' ? 'Welcome back' : 'Welcome to AXtreme');
      nav(redirect ? `/${redirect}` : `/dashboard`);
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || e2.message);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="auth-page">
      <div className="text-[11px] tracking-[0.4em] uppercase opacity-70" style={{ color: t.primary }}>{mode === 'login' ? 'Sign In' : 'Create Account'}</div>
      <h1 className="mt-3 text-4xl" style={{ color: t.text }}>{mode === 'login' ? 'Welcome back' : 'Join AXtreme'}</h1>

      <form onSubmit={submit} className="mt-8 grid gap-4" data-testid={`auth-form-${mode}`}>
        {mode === 'register' && (
          <>
            <input type="text" required placeholder="Full name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className={`p-3 border ${t.accentBorder} bg-transparent`} data-testid="auth-name" />
            <input type="text" placeholder="Phone" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} className={`p-3 border ${t.accentBorder} bg-transparent`} data-testid="auth-phone" />
          </>
        )}
        <input type="email" required placeholder="Email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} className={`p-3 border ${t.accentBorder} bg-transparent`} data-testid="auth-email" />
        <input type="password" required minLength={6} placeholder="Password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} className={`p-3 border ${t.accentBorder} bg-transparent`} data-testid="auth-password" />
        {err && <div className="text-sm text-red-700" data-testid="auth-error">{err}</div>}
        <button type="submit" className={`mt-2 px-6 py-3 text-xs tracking-[0.3em] uppercase ${t.btnPrimary}`} data-testid="auth-submit">{mode === 'login' ? 'Sign In' : 'Create Account'}</button>
      </form>
      <button onClick={() => setMode(mode === 'login' ? 'register' : 'login')} className="mt-6 text-xs tracking-[0.2em] uppercase underline opacity-70" data-testid="auth-toggle">
        {mode === 'login' ? "Don't have an account? Sign up" : 'Have an account? Sign in'}
      </button>
    </div>
  );
}
